<template>
  <div>
    <!--    <Divider orientation="left">单位基本信息</Divider>-->
    <!--    <Form ref="form" :model="form1" :rules="rules" :label-width="180">-->
    <!--      <Row :gutter="16">-->
    <!--        &lt;!&ndash;        <Col span="24">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <FormItem label="业务流水号" prop="id">&ndash;&gt;-->
    <!--        &lt;!&ndash;            <Input v-model="form.id" disabled></Input>&ndash;&gt;-->
    <!--        &lt;!&ndash;          </FormItem>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </Col>&ndash;&gt;-->
    <!--        <Col span="24">-->
    <!--          <FormItem label="重置密码" prop="uniPersonal">-->
    <!--            <RadioGroup v-model="form1.uniPersonal">-->
    <!--              <Radio v-for="select in uniPersonalList" :label="select.value" :key="select.value">{{select.name}}</Radio>-->
    <!--            </RadioGroup>-->
    <!--          </FormItem>-->
    <!--        </Col>-->
    <!--      </Row>-->
    <!--    </Form>-->
    <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">

        <Col span="12">
        <FormItem label="上传申请人身份证人像面" prop="personnelIDCardFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :format='format' :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelIDCardFrontGuid')"
                :on-format-error="handleFormatError" action="//jsonplaceholder.typicode.com/posts/">
                <div style="padding: 23px 0;">
                  <Icon type="ios-add" size="68" style="color: #3399ff"></Icon>
                  <p>上 传 图 片</p>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.personnelIDCardFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/'+ form.personnelIDCardFrontGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.personnelIDCardFrontGuid,'personnelIDCardFrontGuid')" type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传申请人身份证国徽面" prop="personnelIDCardBackGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :format='format' :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelIDCardBackGuid')"
                :on-format-error="handleFormatError" action="//jsonplaceholder.typicode.com/posts/">
                <div style="padding: 23px 0;">
                  <Icon type="ios-add" size="68" style="color: #3399ff"></Icon>
                  <p>上 传 图 片</p>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.personnelIDCardBackGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/'+ form.personnelIDCardBackGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.personnelIDCardBackGuid,'personnelIDCardBackGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人姓名" prop="personnelName">
          <Input v-model="form.personnelName" placeholder="（自动识别身份证，可修改）"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="申请人身份证号" prop="personnelIDCardNo">
          <Input v-model="form.personnelIDCardNo" placeholder="（自动识别身份证，可修改）"></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="申请人联系方式" prop="personnelPhone">
          <Input v-model="form.personnelPhone" placeholder="请填写"></Input>
        </FormItem>
        </Col>

        <Col span="24">
        <FormItem label="上传居住证正面" prop="personnelIDCardFrontGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :accept="accept" :format='format' :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelIDCardFrontGuid')"
                :on-format-error="handleFormatError" action="//jsonplaceholder.typicode.com/posts/">
                <div style="padding: 23px 0;">
                  <Icon type="ios-add" size="68" style="color: #3399ff"></Icon>
                  <p>上 传 图 片</p>
                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.personnelIDCardFrontGuid">
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/'+ form.personnelIDCardFrontGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.personnelIDCardFrontGuid,'personnelIDCardFrontGuid')" type="ios-trash-outline" />
                  </i>
                </span>
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <!-- <Col  span="12">
          <FormItem label="上传居住证反面" prop="personnelIDCardBackGuid">
            <Row :gutter="16">
              <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :accept="accept" :format='format' :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelIDCardBackGuid')"
                          :on-format-error="handleFormatError" action="//jsonplaceholder.typicode.com/posts/">
                    <div style="padding: 23px 0;">
                      <Icon type="ios-add" size="68" style="color: #3399ff"></Icon>
                      <p>上 传 图 片</p>
                    </div>
                  </Upload>
                  <div class="fileList" v-if="form.personnelIDCardBackGuid">
                    <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/'+ form.personnelIDCardBackGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.personnelIDCardBackGuid,'personnelIDCardBackGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                  </div>
                  <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
                  </div>
                </div>
              </Col>
            </Row>
          </FormItem>
        </Col> -->

        <Col span="12">
        <FormItem label="居住证有效期" prop="personnelName">
          <Input v-model="form.personnelName" placeholder="（自动识别居住证，可修改）"></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="居住证地址" prop="personnelName">
          <Input v-model="form.personnelName" placeholder="（自动识别身份证，可修改）"></Input>
        </FormItem>
        </Col>
        <!--        <Col span="24">-->
        <!--          <FormItem label="在沪居住(或入户)地址" prop="zhjzdz">-->
        <!--            <Input v-model="form.zhjzdz" placeholder="RPA自动抓取"></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <!--        <Col span="8">-->
        <!--          <FormItem label="邮编" prop="yb">-->
        <!--            <Input v-model="form.yb" placeholder="RPA自动抓取"></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <!--        <Col span="8">-->
        <!--          <FormItem label="联系电话" prop="lxdh">-->
        <!--            <Input v-model="form.lxdh" placeholder="RPA自动抓取"></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <!--        <Col span="8">-->
        <!--          <FormItem label="手机号" prop="sjh">-->
        <!--            <Input v-model="form.sjh" placeholder="RPA自动抓取"></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <!--        <Col span="24">-->
        <!--          <FormItem label="是否变更户籍地址" prop="uniPersonal">-->
        <!--            <RadioGroup v-model="form1.uniPersonal">-->
        <!--              <Radio v-for="select in uniPersonalList" :label="select.value" :key="select.value">{{select.name}}</Radio>-->
        <!--            </RadioGroup>-->
        <!--          </FormItem>-->
        <!--        </Col>-->

        <!--        <Col span="12">-->

        <!--        </Col>-->
        <!--        <Col span="12">-->
        <!--          <FormItem label="撤回原因" prop="hjd">-->
        <!--            <Input v-model="form.chyy" placeholder="RPA自动抓取"></Input>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <!--        <Col span="12">-->

        <!--        </Col>-->
        <!--        <Col span="12" v-if="form1.uniPersonal!='0'">-->
        <!--          <FormItem label="变更后的户籍地材料" prop="personnelLetterGuid">-->
        <!--            <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">-->
        <!--              <Button icon="ios-cloud-upload-outline">点击上传</Button>-->
        <!--            </Upload>-->
        <!--          </FormItem>-->
        <!--        </Col>-->
        <Col span="12">
        <FormItem label="前单位退工单" prop="personnelLetterGuid">
          <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="劳动（聘用）合同" prop="personnelLetterGuid">
          <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="其他材料" prop="personnelLetterGuid">
          <Upload action="//jsonplaceholder.typicode.com/posts/" :data="uploadData" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid')" :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
        </FormItem>
        </Col>
      </Row>
      <div class="bom_btn">
        <div>
          <Button @click="submitStore()">暂存</Button>
          <Button type="primary" @click="next('form'+current,appInfoDataType['申请人基本信息'])">提交</Button>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
export default {
  // props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      form: {},
      form1: { uniPersonal: 1 },
      current: {},
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      ywlbList: [
        {
          name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
          value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
        },
      ],
      rules: {
        ywlb: [{ required: true, message: '请输入', trigger: 'change' }],
        // sbsx: [{ required: true, message: '请输入', trigger: 'change' }],
        // sfzzm: [{ required: false, message: '请上传', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
      uniPersonalList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$emit('next', val, `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`)
      })
    },
    //暂存
    async submitStore() {
      this.$emit('next', this.current, `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`)
      //   try {
      //     const { data } = await this.$Ajax.post(
      //       `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`,
      //       this.form
      //     )
      //      this.$Message.success({
      //       content: '暂存成功',
      //       background:true,
      //       duration: 6
      //     })
      //   } catch (error) {
      //      this.$Message.error({
      //       content: '出错了',
      //       background:true,
      //       duration: 6
      //     })
      //   }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', index, guid, property)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property) {
      this.$emit('handleSuccess', response, file, fileList, property)
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
  },
}
</script>
<style lang="less" scoped>
.bom_btn {
  padding: 20px;
  // width: 50%;
  display: flex;
  justify-content: space-around;
  /deep/.ivu-btn {
    padding: 0px 30px;
    margin: 0px 40px;
  }
}
.line_area {
  display: flex;
  flex-wrap: wrap;
}
.fileList {
  display: flex;
  max-width: 148px;
  max-height: 148px;
  background: #fff;
  background: #eee;
  margin-left: 20px;
  border-radius: 5px;
  overflow: hidden;
  // flex-wrap: wrap;
}

.img {
  margin-right: 10px;
}
.pos {
  position: relative;
}
.pos:hover .img_magnify {
  display: inline-block;
}
.ico {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.img_magnify {
  display: none;
  background: rgba(0, 0, 0, 0.459);
  position: absolute;
  z-index: 1;
  width: 148px;
  height: 148px;
  left: 0px;
  right: 0;
  top: 0;
  bottom: 0;
}

.uploadImage {
  width: 148px;
  height: 148px;
}
.uploadImageNo {
  width: 148px;
  height: 148px;
  display: inline-block;
  line-height: 148px;
  text-align: center;
}
.notice {
  color: #ff9900;
  font-size: 13px;
  margin-bottom: 10px;
}
.noticeTop {
  margin-bottom: 0px;
}
.noticeTop /deep/.ivu-form-item-content {
  display: flex;
}

.noticeIcon {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  color: #ff9900;
  border: 2px solid #ff9900;
  border-radius: 50%;
  line-height: 16px;
  font-weight: bold;
  font-family: 'Ionicons';
}
</style>
